const { addActions } = require('js-data-http')
const { Schema, Mapper } = require('js-data')

// Valid Schema according to the http://json-schema.org/ v4 specification.
const campaign_schema = new Schema({
  title: "Campaign",
  description: "Campaign schema for validation",
  additionalProperties: true,
  required: ["name","start_date"],
  type: "object",
  properties: {
    name: {
      type: "string",
      minLength: 1,
      maxLength: 255
    },
    start_date: {
      type: ["null","string","object"]
    },
    end_date: {
      type: ["null","string","object"]
    }
  }
})

class CampaignMapper extends Mapper {

  validate (record, opts = {}) {
    let _campaign = (record.campaign instanceof require('./record')) ? record.campaign : record
    opts.existingOnly = false
    return false
  }

}

let mapper_options = {
  name: 'campaign',
  endpoint: 'campaigns',
  recordClass: require('./record'),
  mapperClass: CampaignMapper,
  schema: campaign_schema,
  relations: {
    hasOne: {
      invitation: {
        foreignKey: 'campaign_id',
        localField: 'invitation'
      },
      landing_page: {
        foreignKey: 'campaign_id',
        localField: 'landing_page'
      }
    },
    hasMany: {
      share_setting: {
        foreignKey: 'campaign_id',
        localField: 'share_settings'
      },
      allocation_detail: {
        foreignKey: 'campaign_id',
        localField: 'allocation_details'
      },
      registration_key: {
        foreignKey: 'campaign_id',
        localField: 'registration_keys'
      },
      digital_asset: {
        foreignKeys: 'campaign_ids',
        localField: 'digital_assets'
      },
      communication: {
        foreignKey: 'campaign_id',
        localField: 'communications'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('campaign', mapper_options)
  addActions({
    reset: {
      pathname: 'reset',
      method: 'POST'
    },
    bulk_update_share_settings: {
      pathname: 'share_settings/bulk_update',
      method: 'PUT'
    }
  })(mapper)
}
